module.exports = {
  "de": {
    "theme-admin": {
      "toggle-navigation": "Navigation einblenden / ausblenden"
    },
    "ui-kit": {
      "under-construction": {
        "work-in-progress": "In Arbeit...",
        "feature-in-dev": "Diese Funktion wird momentan entwickelt. Bitte versuchen Sie es zu einem späteren Zeitpunkt."
      },
      "table": {
        "not-specified": "Keine Angaben"
      },
      "select": {
        "select": "Bitte wählen...",
        "select-or-start-typing": "Bitte wählen Sie oder beginnen Sie mit der Eingabe...",
        "no-results": "Keine Resultate vorhanden",
        "loading": "Laden...",
        "search-prompt": "Beginnen Sie mit der Eingabe um zu suchen",
        "screen-reader-status": "{{count}} result available",
        "screen-reader-status_plural": "{{count}} results available"
      },
      "alert": {
        "close": "Schliessen"
      },
      "empty": {
        "text": "Momentan sind keine Elemente vorhanden."
      }
    },
    "default": {
      "email": "E-Mail",
      "password": "Passwort",
      "logging-in": "Die Verbindung wird hergestellt",
      "statistics": "Statistiken",
      "ads": "Anzeigen",
      "bills": "Rechnungen",
      "dashboard": "Dashboard",
      "welcome": "Willkommen",
      "logout": "Logout",
      "login": "Login",
      "back-to-login": "Zurück zur Login-Seite",
      "previous": "Zurück",
      "next": "Weiter",
      "yes": "Ja",
      "no": "Nein",
      "status": "Status",
      "deactivated": "Deaktivieren",
      "activated": "Aktiviert",
      "published": "Veröffentlicht",
      "expired": "Expirée",
      "not-published": "Unveröffentlicht",
      "drafted": "Verfasst",
      "disabled": "Deaktiviert",
      "delete": "Löschen",
      "manufacturers": "Hersteller",
      "category": "Kategorie",
      "manufacturer": "Hersteller",
      "entities": "Einheiten",
      "ad-conditions": "Objektzustand",
      "loading": "Wird geladen…",
      "name": "Name",
      "ad-condition": "Zustand",
      "price": "Preis",
      "price-tax-excl": "Preis exkl. MwSt.",
      "tax-excl": "exkl. MwSt.",
      "categories": "Kategorien",
      "bookmarks": "Favoriten",
      "my-searches": "Meine Suchen",
      "pricing": "Tarife",
      "about": "Über uns",
      "contact": "Kontakt",
      "search": "Suchen",
      "admininitraton": "Administration",
      "sell": "Verkaufen",
      "my-machine": "Meine Maschine",
      "public-site": "Öffentliche Website",
      "seo": "SEO",
      "subscribe": "Abonnieren",
      "account": "Konto",
      "advertiser": "Inserent",
      "publish": "Veröffentlichen",
      "extend": "Prolonger",
      "weight": "Gewicht",
      "tons": "Kg",
      "hours": "Stunden",
      "icon": "Symbol",
      "excavator": "Bagger",
      "bulldozer": "Planierraupe",
      "dump-truck": "Muldenkipper",
      "compactor": "Compactor",
      "crane": "Kran",
      "crane-truck": "Kranwagen",
      "concasseur": "Concasseur",
      "send": "Senden",
      "message": "Nachrichteninhalt",
      "locality": "Ort",
      "profile": "Profil",
      "first-name": "Vorname",
      "last-name": "Nachname",
      "save": "Speichern",
      "company": "Firma",
      "phone-number": "Telefonnummer",
      "street-address": "Adresse",
      "ad-priority": "Top-Kategorie",
      "modify": "Ändern",
      "disable": "Deaktivieren",
      "enable": "Aktivieren",
      "all": "Alle",
      "displayed": "Angezeigt",
      "avatar": "Avatar",
      "saving": "Speichervorgang läuft",
      "add-file": "Datei hinzufügen",
      "drop-file-here": "Ziehen Sie Ihre Dateien und legen Sie sie hier ab",
      "draft": "Verfassen",
      "add-photos": "Fotos hinzufügen",
      "preview": "Vorschau",
      "logo": "Logo",
      "finalize": "Abschliessen",
      "publishing": "Veröffentlichung",
      "extension": "Prolongement",
      "total-due": "Zahlbarer Gesamtbetrag",
      "total-credits": "Total des crédits",
      "total-to-use": "Total à utiliser",
      "missing-you": "Il vous manque",
      "depict": "Fotos hinzufügen",
      "checkout": "Zahlen",
      "see": "Ansehen",
      "banned": "Gebannt",
      "unbanned": "Entbannt",
      "ban": "Bannen",
      "unban": "Entbannen",
      "previewed": "Vorschau",
      "expire-on": "Verfällt am",
      "expire-since": "Expirée depuis le",
      "extend-an-ad": "Prolonger une annonce",
      "description": "Beschreibung",
      "quantity": "Anzahl",
      "total-price": "Gesamtpreis",
      "issue-date": "Ausstellungsdatum",
      "free": "Kostenlos",
      "vat-rate": "MWST {{rate}}%",
      "final-total": "Gesamtbetrag inkl. MwSt.",
      "credits": "Crédits",
      "buy": "Kaufen",
      "buy-credits": "Acheter des crédits",
      "payment": "Paiement",
      "credits-bought": "gekaufte Kredite",
      "credits-used": "verwendete Kredite",
      "credits-voucher": "crédits offerts",
      "advertisers": "Annonceurs",
      "add-credits-to": "Ajouter des crédits à {{name}}",
      "credits-added": "Crédits ajoutés",
      "pdf-file": "Fichier PDF",
      "approve-publish": "Genehmigen und veröffentlichen",
      "payment-pending": "Ausstehende Zahlung",
      "order-paid": "Bezahlte Bestellung",
      "order-canceled": "Stornierte Bestellung",
      "order-refunded": "Bestellung zurückerstattet",
      "showcases": "Showcases",
      "showcase": "Showcase",
      "title": "Titre",
      "lead": "Chapô",
      "body": "Corps",
      "medias": "Photos et Video",
      "link": "Lien",
      "featured": "Accueil",
      "close-search": "Fermer la recherche",
      "modify-search": "Modifier la recherche",
      "price-on-demand": "Preis auf Anfrage",
      "download": "Runterladen",
      "empty-list": "Leere Liste",
      "all-ads": "Alle Anzeigen",
      "banners": "Bannières",
      "banner": "Bannière",
      "start-date": "Date de début",
      "end-date": "Date de fin",
      "format": "Format",
      "desktop": "Desktop",
      "mobile": "Mobile",
      "image": "Image",
      "url": "URL",
      "country": "Pays",
      "currency": "Währung",
      "desktop-and-mobile": "Desktop et Mobile",
      "email-address-link": "Sie haben einen Link auf {{email}} erhalten, den Sie anklicken müssen, um Ihre E-Mail-Adresse zu bestätigen.",
      "email-address-required": "Sie müssen Ihre E-Mail-Adresse bestätigen, um Anzeigen zu veröffentlichen.",
      "email-address-not-confirmed": "Ihre E-Mail Adresse wurde noch nicht bestätigt.",
      "send-email-confirmation": "Senden Sie mir die Bestätigungs-E-Mail",
      "email-address-confirmation-sent": "Die Bestätigungs-E-Mail wurde gesendet",
      "at-email": "an {{E-Mail}}",
      "ad-bookmark-added": "Anzeige zu Favoriten hinzugefügt",
      "ad-bookmark-removed": "Anzeige aus Favoriten entfernt",
      "remove-from-bookmarks": "Aus Favoriten entfernen",
      "add-to-bookmarks": "Zu den Favoriten hinzufügen",
      "ad-bookmark-add-sign-in": "Melden Sie sich an, um diese Anzeige zu Ihren Favoriten hinzuzufügen.",
      "click-here-to-sign-in": "Klicken Sie hier, um sich kostenlos anzumelden",
      "operation-hours-count": "{{count}} Std.",
      "operation-hours-count_plural": "{{count}} Stdn.",
      "tons-count": "{{count}} Kg",
      "tons-count_plural": "{{count}} Kg",
      "left-count": "{{count}} restant",
      "left-count_plural": "{{count}} restants",
      "credit-count": "{{count}} Kredit",
      "credit-count_plural": "{{count}} Kredite",
      "day": "jour",
      "day_plural": "jours",
      "credit": "Kredit",
      "credit_plural": "Kredite",
      "credits-available": "verfügbare Kredite",
      "back-to-ad": "Zurück zur Anzeige",
      "modify-price": "Preis ändern",
      "modify-photos": "Fotos ändern",
      "machine-place": "Die Maschine befindet sich in (Ort)",
      "publish-an-ad": "Eine Anzeige veröffentlichen",
      "execute-search": "Suche starten",
      "back-to-ads": "Zurück zu den Anzeigen",
      "back-to-profile": "Zurück zum Profil",
      "back-to-account": "Zurück zu meinem Konto",
      "back-to-bills": "Zurück zu den Rechnungen",
      "operation-hours": "Einsatzstunden",
      "checkout-payment": "Zur Zahlung",
      "checkout-credits": "Utiliser mes crédits",
      "main-photo-first": "Das Hauptfoto wählen (ziehen)",
      "type-card-details": "Ihre Kreditkarteninformationen eingeben",
      "number-name-street": "Strasse und Nummer",
      "available-for-rent": "Zur Vermietung verfügbar",
      "write-a-description": "Eine Beschreibung verfassen",
      "postal-code-locality": "PLZ und Ort",
      "postal-code-or-locality": "PLZ und Ort",
      "country-locality": "Pays et localité",
      "topbar-first-sentence": "Neue und gebrauchte Baumaschinen",
      "drag-drop-files-here-or-click": "Ziehen Sie Ihre Dateien und legen Sie sie hier ab oder klicken Sie auf die Schaltfläche",
      "please-select-or-type-category": "Eine Kategorie eingeben oder auswählen",
      "please-select-or-type-manufacturer": "Eine Marke eingeben oder auswählen",
      "please-type-at-least-3-characters": "Geben Sie bitte mindestens 3 Zeichen ein",
      "select-credits-package": "Wählen Sie die Kreditanzahl, die für Sie am interessantesten ist",
      "matches-a-value": "entspricht einem Wert von",
      "by-credit-unit": "pro Krediteinheit",
      "account-credited": "Votre compte a reçu les crédits.",
      "confirm-payment": "Die Zahlung bestätigen",
      "amount-due": "Zahlbarer Betrag",
      "billing-data": "Rechnungsinformationen",
      "billing-intro-credit": "Pour acheter des crédits, vous devez renseigner les informations concernant votre facturation.",
      "save-buy-credit": "Enregistrer et acheter des crédits",
      "system-confirmation": "Wir warten auf eine endgültige Bestätigung vom Zahlungssystem.",
      "could-take-seconds": "Dies dauert einige Sekunden.",
      "checkout-choose-options": "Choix des options de l'annonce",
      "extend-expired-ad": "L'annonce est expirée depuis",
      "extend-published-ad": "L'annonce est publiée et va expirer dans",
      "use-credits-to extend-ad": "Utilisez des crédits pour prolonger la durée de sa publication et de ses options.",
      "ad-has-been-extended": "L'annonce a été prolongée.",
      "sort": "Sortieren",
      "sort-ascending-expiration-date": "Datum (vom neuesten)",
      "sort-descending-expiration-date": "Datum (vom ältesten)",
      "sort-ascending-price": "Aufsteigender Preis",
      "sort-descending-price": "Absteigender Preis",
      "ad-options": {
        "ad-featured-description": "Aktivieren Sie die Option 'In erster Linie', damit Ihre Anzeige während der gesamten Veröffentlichungsdauer ( {{duration}} Tage ) auf der Homepage im Kasten 'Maschinen im Fokus' erscheint.",
        "ad-priority-description": "Aktivieren Sie die Option 'Top-Kategorie', damit Ihre Anzeige während der gesamten Veröffentlichungsdauer ( {{duration}} Tage ) in erster Linie auf der Seite erscheint, die ihrer Kategorie (Bagger, Lader, usw.) im Kasten 'Top-Maschinen' entspricht.",
        "ad-publishing-description": "Ihre Anzeige erscheint einen Monat lang (30 Tage) in allgemeinen Suchanfragen und in ihrer Kategorie. Über das Kontaktformular können Interessenten direkt mit Ihnen Kontakt aufnehmen. Nach Ablauf der 30 Tage ( {{duration}} ) haben Sie auf Wunsch die Möglichkeit, die Veröffentlichung der Anzeige zu verlängern.",
        "ad-extension-description": "Prolongement de la durée de publication de l'annonce."
      },
      "call-advertiser": "Den Verkäufer anrufen",
      "find-the-right-machine": {
        "part1": "Finden Sie",
        "part2": "in wenigen Klicks",
        "part3": "die gewünschte Baumaschine!"
      },
      "read-more": "Lesen Sie mehr dazu auf chantiersmagazine.ch",
      "footer": {
        "ad": "Werbung",
        "legal-information": "Rechtliche Informationen",
        "for-professionnals": "Für Profis",
        "chantiers-machine": "Maschinen @Chantiers",
        "use-and-sale-conditions": "Allgemeine Nutzungs- und Verkaufsbedingungen",
        "privacy-policy": "Datenschutzbestimmungen",
        "machine-sales-professionnals": "Maschinenverkaufsprofis",
        "contact-us": "Kontakt",
        "prices": "Preise",
        "copyrights": {
          "trademark": "2021 Cemento Éditions. Alle Rechte vorbehalten.",
          "developer": "Web-Entwicklung",
          "designer": "Webdesign"
        }
      }
    },
    "error": {
      "common": "Ein Fehler ist aufgetreten. Bitte laden Sie die Seite neu und versuchen Sie es erneut.",
      "mandatory-fields": "Bitte füllen Sie die erforderlichen Felder aus.",
      "disconnected-network": "Es ist ein Netzwerkfehler aufgetreten. Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.",
      "not-found": "Element nicht gefunden. Bitte laden Sie die Seite neu und versuchen Sie es erneut.",
      "email-confirmation-pending": "Ihr Konto muss noch bestätigt werden. Bitte überprüfen Sie Ihren E-Mail-Posteingang.",
      "user-already-exists": "Mit dieser E-Mail-Adresse ist bereits ein Konto verknüpft. Bitte gehen Sie zur Login-Seite, um sich anzumelden.",
      "email-send-error": "Beim E-Mail-Versand ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal.",
      "user-activation": "Beim Aktivieren des Benutzerkontos ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal.",
      "user-deactivated": "Das Konto wurde deaktiviert",
      "password-reset": "Beim Zurücksetzen des Passworts ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal.",
      "ad-not-found": "Es wurden keine Anzeigen mit diesem Benutzernamen gefunden",
      "manufacturer-not-found": "Es wurde kein Hersteller mit diesem Benutzernamen gefunden",
      "manufacturer-linked": "Dieser Hersteller wird in {{count}} Anzeige verwendet. Stellen Sie bitte sicher, dass Sie die Anzeige gelöscht haben, bevor Sie fortfahren.",
      "manufacturer-linked_plural": "Dieser Hersteller wird in {{count}} Anzeigen verwendet. Stellen Sie bitte sicher, dass Sie die Anzeigen gelöscht haben, bevor Sie fortfahren.",
      "ad-condition-not-found": "Es wurde kein Objektzustand mit diesem Benutzernamen gefunden",
      "ad-condition-linked": "Dieser Objektzustand wird in {{count}} Anzeige verwendet. Stellen Sie bitte sicher, dass Sie die Anzeige gelöscht haben, bevor Sie fortfahren.",
      "ad-condition-linked_plural": "Dieser Objektzustand wird in {{count}} Anzeigen verwendet. Stellen Sie bitte sicher, dass Sie die Anzeigen gelöscht haben, bevor Sie fortfahren.",
      "category-not-found": "Es wurde keine Kategorie mit diesem Benutzernamen gefunden",
      "delayed-email-send-failed": "Beim Senden der E-Mail ist ein Fehler aufgetreten. Ein neuer Sendeversuch wird später unternommen. Sie können diese Seite verlassen.",
      "ad-approve-error": "Die Anzeige kann nicht bestätigt und veröffentlicht werden. Entweder lässt es der aktuelle Status nicht zu, oder Sie haben nicht die erforderlichen Berechtigungen.",
      "ad-disable-error": "Die Anzeige kann nicht deaktiviert werden. Entweder lässt es der aktuelle Status nicht zu, oder Sie haben nicht die erforderlichen Berechtigungen.",
      "ad-enable-error": "Die Anzeige kann nicht aktiviert werden. Entweder lässt es der aktuelle Status nicht zu, oder Sie haben nicht die erforderlichen Berechtigungen.",
      "ad-ban-error": "Die Anzeige kann nicht gebannt werden. Entweder lässt es der aktuelle Status nicht zu, oder Sie haben nicht die erforderlichen Berechtigungen.",
      "ad-unban-error": "Die Anzeige kann nicht entbannt werden. Entweder lässt es der aktuelle Status nicht zu, oder Sie haben nicht die erforderlichen Berechtigungen.",
      "ad-extend-error": "L'annonce ne peut pas être prolongée. Soit son état actuel ne le permet, soit vous n'avez pas les permissions nécessaires.",
      "file-type-not-accepted": "Dieser Dateityp wird nicht akzeptiert",
      "only-file-types-allowed": "Nur erlaubte Dateitypen",
      "ad-media-max": "Maximale Bildanzahl erreicht ({{count}})",
      "ad-media-min": "Bitte bewahren Sie mindestens ein Foto auf. Fügen Sie ein weiteres hinzu, bevor Sie dieses löschen.",
      "following-medias-errors-occured": "Folgende Dateifehler sind aufgetreten",
      "ad-depict-failed": "Bitte fügen Sie mindestens ein Foto hinzu",
      "order-create-failed": "Bestelllung fehlgeschlagen. Bitte überprüfen Sie Ihre Rechnungsdaten und Veröffentlichungsoptionen.",
      "order-payment-setup-failed": "Zahlungsauslösung fehlgeschlagen. Bitte wenden Sie sich an den Website-Administrator.",
      "ad-set-price-error": "Beim Speichern des Preises ist ein Fehler aufgetreten. Bitte überprüfen Sie die Gültigkeit des Preises.",
      "static-page-not-found": "Es wurde keine Seite mit diesem Benutzernamen gefunden",
      "credit-not-enough": "Crédits insuffisants",
      "credit-use-failed": "Erreur lors de l'utilisation des crédits",
      "advertiser-not-found": "Aucun annonceur n'as été trouvé avec cet identifiant",
      "video": "Le format du lien est non valide.",
      "showcase-media-max": "Maximale Bildanzahl erreicht ({{count}})",
      "showcase-media-min": "Bitte bewahren Sie mindestens ein Foto auf. Fügen Sie ein weiteres hinzu, bevor Sie dieses löschen."
    },
    "example": {
      "year": "z.B. 2015",
      "phone-number": "z.B. +41 22 300 55 88"
    },
    "footer": {
      "ad-part1": "Möchten Sie eine",
      "ad-part2": "Baumaschine verkaufen?",
      "ad-button": "Geben Sie Ihre Anzeige auf"
    },
    "packages": {
      "unit": "Einheit Kredit",
      "pro100": "Pack Pro 100",
      "pro500": "Pack Pro 500",
      "pro1500": "Pack Pro 1500"
    },
    "pages": {
      "account": {
        "page-title": "Konto",
        "welcome": "Willkommen"
      },
      "ad-conditions": {
        "page-title": "Zustand des verkauften Artikels",
        "add-ad-condition": "Objektzustand hinzufügen",
        "ad-condition-added": "Der Objektzustand wurde korrekt hinzugefügt",
        "name": "Name des Zustands",
        "edit-ad-condition": "Einen Objektzustand ändern",
        "ad-condition-edited": "Der Objektzustand wurde korrekt geändert",
        "searching-ad-condition": "Objektzustand wird geladen",
        "confirm-ad-condition-delete": "Möchten Sie diesen Objektzustand wirklich löschen?",
        "ad-condition-deleted": "Der Objektzustand wurde korrekt gelöscht"
      },
      "ads": {
        "model-name": "Modellbezeichnung",
        "construction-year": "Baujahr",
        "create-ad": "Eine Anzeige hinzufügen",
        "enable-ad": "Die Anzeige aktivieren",
        "ad-created": "Die Anzeige wurde korrekt hinzugefügt",
        "edit-ad": "Eine Anzeige ändern",
        "ad-edited": "Die Anzeige wurde korrekt geändert",
        "searching-ad": "Die Anzeige wird geladen",
        "confirm-ad-delete": "Möchten Sie diese Anzeige wirklich löschen?",
        "confirm-ad-approve": "Möchten Sie diese Anzeige wirklich bestätigen und veröffentlichen?",
        "confirm-ad-disable": "Möchten Sie diese Anzeige wirklich deaktivieren?",
        "confirm-ad-enable": "Möchten Sie diese Anzeige wirklich aktivieren?",
        "confirm-ad-ban": "Möchten Sie diese Anzeige wirklich bannen?",
        "confirm-ad-unban": "Möchten Sie diese Anzeige wirklich entbannen?",
        "confirm-ad-extend": "Voulez-vous vraiment prolonger la publication de cette annonce ?",
        "ad-deleted": "Die Anzeige wurde korrekt gelöscht",
        "ad-approved": "Die Anzeige wurde genehmigt",
        "ad-disabled": "Die Anzeige wurde deaktiviert",
        "ad-enabled": "Die Anzeige wurde aktiviert",
        "ad-banned": "Die Anzeige wurde gebannt",
        "ad-unbanned": "Die Anzeige wurde entbannt",
        "ad-extended": "La publication de l'annonce a été prolongée",
        "description": "Beschreibung",
        "contact": "Eine Nachricht senden",
        "example-name": "z.B. Jean Dubat",
        "example-email": "z.B. jean.dubat@bluewin.ch",
        "write-a-message": "Guten Tag,\n\nIhre Anzeige interessiert mich. ist das Objekt immer noch verfügbar?\n\nMit freundlichen Grüssen,",
        "ad-contacted": "Die Kontakt-E-Mail wurde erfolgreich gesendet",
        "phone-number": "Telefonnummer",
        "phone-number-example": "z.B. +41 22 300 55 88",
        "ad-title": "{{manufacturer}} {{modelName}} von {{year}} in {{locality}} | {{condition}} | {{price}}",
        "is-featured": "Auf der ersten Seite",
        "share": {
          "mail-subject": "Cette annonce peut vous intéresser",
          "mail-body": "J'ai vu cette annonce sur {{url}}.\n\nJetez-y un coup d'œil !"
        }
      },
      "advertiser-ads": {
        "page-title": "Meine Anzeigen",
        "display-name": "Name",
        "state": "Veröffentlichungsstatus",
        "no-data": "Sie haben noch keine Anzeige veröffentlicht",
        "start-publishing-ad": "Ihre erste Anzeige veröffentlichen"
      },
      "advertiser-bookmarks": {
        "page-title": "Meine Lieblingsanzeigen",
        "no-data": "Sie haben keine Anzeigen in Ihren Favoriten",
        "confirm-bookmark-remove": "Möchten Sie diese Anzeige wirklich aus Ihren Favoriten entfernen ?"
      },
      "advertiser-orders": {
        "no-data": "Sie haben keine Rechnung"
      },
      "avatar": {
        "page-title": "Avatar",
        "upload-your-avatar": "Laden Sie Ihren Avatar oder Ihr Firmenlogo hoch",
        "confirm-delete": "Möchten Sie Ihren Avatar wirklich löschen ?"
      },
      "banners": {
        "banners": "Bannières",
        "add-banner": "Ajouter une bannière",
        "banner-added": "La bannière a été correctement ajoutée",
        "edit-banner": "Modifier une bannière",
        "banner-edited": "La bannière a été correctement modifiée",
        "searching-banner": "Chargement de la bannière",
        "confirm-delete": "Voulez-vous vraiment supprimer cette image ?",
        "confirm-banner-delete": "Voulez-vous vraiment supprimer cette bannière ?",
        "banner-deleted": "La bannière a été correctement supprimée",
        "halfpage": "Halfpage",
        "billboard": "Billboard",
        "medium-rectangle": "Medium Rectangle",
        "leaderboard": "Leaderboard",
        "missing-banner": "Version de bannière manquante pour l'affichage publique."
      },
      "bills": {
        "order-items": "Artikel der Bestellung",
        "billed-to": "Fakturiert an",
        "bill-reference": "Rechnungsreferenz"
      },
      "categories": {
        "sub-category": "{{count}} Unterkategorie",
        "sub-category_plural": "{{count}} Unterkategorien",
        "sub-categories": "Unterkategorien",
        "add-sub-category": "Eine Unterkategorie hinzufügen",
        "back-to-category": "Zurück zur letzten Kategorie",
        "add-category": "Eine Kategorie hinzufügen",
        "parent": "Verwandte Kategorie",
        "name": "Kategoriename",
        "edit-category": "Eine Kategorie ändern",
        "category-added": "La catégorie a été correctement ajoutée",
        "category-edited": "Die Kategorie wurde korrekt geändert",
        "searching-category": "Die Kategorie laden",
        "confirm-category-delete": "Möchten Sie diese Kategorie wirklich löschen?",
        "category-deleted": "Die Kategorie wurde korrekt gelöscht"
      },
      "home": {
        "title": "Neue und gebrauchte Baumaschinen"
      },
      "login": {
        "page-title": "In Ihr Konto einloggen",
        "submit": "Einloggen",
        "wrong-login-credentials": "Die eingegebene E-Mail-Adresse und das Passwort stimmen nicht überein",
        "inactive-account": "Ihre E-Mail Adresse wurde noch nicht bestätigt",
        "error-login": "Das Senden des Formulars ist fehlgeschlagen, bitte versuchen Sie es erneut",
        "forgotten-password": "Passwort vergessen",
        "no-account": "Sie haben noch kein Konto?",
        "click-here-signin": "Klicken Sie hier, um sich kostenlos anzumelden"
      },
      "manufacturers": {
        "manufacturers": "Hersteller",
        "name": "Name des Herstellers",
        "logo": "Logo",
        "is-featured": "In erster Linie",
        "add-manufacturer": "Ein Hersteller hinzufügen",
        "manufacturer-added": "Der Hersteller wurde korrekt hinzugefügt",
        "edit-manufacturer": "Einen Hersteller ändern",
        "manufacturer-edited": "Der Hersteller wurde korrekt geändert",
        "searching-manufacturer": "Hersteller wird geladen",
        "confirm-manufacturer-delete": "Möchten Sie diesen Hersteller wirklich löschen?",
        "manufacturer-deleted": "Der Hersteller wurde korrekt gelöscht"
      },
      "media": {
        "page-title": "Anzeigenfotos",
        "upload-your-photos": "Laden Sie die Fotos der Anzeige hoch. Maximal 10 Bilder.",
        "confirm-delete": "Möchten Sie dieses Foto wirklich löschen?",
        "sort-your-photos": "Ändern Sie die Reihenfolge der Fotos der Anzeige.",
        "youtube-link": "Renseigner le lien YouTube vers votre video. Elle sera affichée après vos photos.",
        "confirm-video-delete": "Êtes-vous sûr de vouloir supprimer cette vidéo ?",
        "video-delete": "Supprimer la vidéo de l'annonce",
        "confirm-file-delete": "Êtes-vous sûr de vouloir supprimer ce fichier ?",
        "upload-one-pdf-document": "Déposer un seul fichier PDF."
      },
      "not-found": {
        "page-title": "Seite nicht gefunden",
        "page-not-found": "Seite nicht gefunden",
        "page-has-not-been-found": "Die Seite wurde nicht gefunden"
      },
      "orders": {
        "page-title": "Meine Rechnungen"
      },
      "pages": {
        "page-title": "Seiten",
        "edit-page": "Die Seite ändern",
        "page-edited": "Die Seite wurde korrekt geändert",
        "searching-page": "Die Seite wird geladen",
        "title": "Titel",
        "slug": "Slug",
        "content": "Inhalt"
      },
      "password-recovery": {
        "page-title": "Passwort vergessen?",
        "submit": "Anweisungen zum Zurücksetzen senden",
        "email-account": "Bitte geben Sie die für Ihr Konto verwendete E-Mail-Adresse ein",
        "reset-instructions": "Anweisungen zum Zurücksetzen Ihres Passworts werden Ihnen an diese Adresse geschickt",
        "instructions-sent": "Ein Link zum Zurücksetzen Ihres Passworts wurde an Ihre E-Mail-Adresse gesendet"
      },
      "password-reset": {
        "page-title": "Ihr Passwort ändern",
        "help": "Sie können jetzt Ihr Passwort zurücksetzen (ändern)",
        "choose-new": "Geben Sie ein neues Passwort ein",
        "repeat-password": "Wiederholen Sie das neue Passwort",
        "submit": "Das Passwort ändern",
        "success": "Das Passwort wurde erfolgreich geändert",
        "login-redirect": "Sie werden automatisch eingeloggt und zur Startseite weitergeleitet."
      },
      "price": {
        "page-title": "Anzeigenpreis",
        "edit-saved": "Registrierter Preis"
      },
      "profile": {
        "page-title": "Profil",
        "saved": "Registriertes Profil"
      },
      "publish": {
        "page-title": "Eine Anzeige veröffentlichen",
        "click-to-see": "Klicken Sie hier, um Ihre Anzeige zu sehen",
        "billing-intro": "Um eine Anzeige zu veröffentlichen, müssen Sie die Rechnungsinformationen ausfüllen",
        "save-next": "Eine Anzeige speichern und verfassen",
        "not-yet-publish": "Ihre Anzeige ist noch nicht veröffentlicht",
        "publish-continue": "Wählen Sie Ihre Optionen und fahren Sie mit der Zahlung fort, um die Veröffentlichung abzuschliessen",
        "payment-finalize": "Fahren Sie mit der Zahlung fort, um die Veröffentlichung abzuschliessen",
        "billing-data": "Rechnungsinformationen",
        "save-and-depict": "Speichern und Fotos hinzufügen",
        "save-and-checkout": "Speichern und die Anzeige veröffentlichen",
        "save-and-preview": "Speichern und Vorschau",
        "confirm-payment": "Die Zahlung bestätigen",
        "amount-due": "Zahlbarer Betrag",
        "email-confirmation": "Sie erhalten eine Bestätigungs-E-Mail, sobald die Anzeige veröffentlicht ist",
        "add-video": "Ajouter la vidéo YouTube"
      },
      "showcases": {
        "showcases": "Showcases",
        "add-showcase": "Ajouter un showcase",
        "showcase-added": "Le showcase a été correctement ajouté",
        "edit-showcase": "Modifier un showcase",
        "showcase-edited": "Le showcase a été correctement modifié",
        "searching-showcase": "Chargement du showcase",
        "confirm-showcase-delete": "Voulez-vous vraiment supprimer ce showcase ?",
        "showcase-deleted": "Le showcase a été correctement supprimé",
        "showcase-activated": "Le showcase a été correctement activé",
        "showcase-deactivated": "Le showcase a été correctement désactivé",
        "showcase-featured": "Le showcase a été ajouté à la page d'accueil",
        "showcase-remove-featured": "Le showcase a été retiré de la page d'accueil"
      },
      "sign-up": {
        "page-title": "Kostenlose Anmeldung",
        "already-have-an-account": "Haben Sie schon ein Konto?",
        "click-here-login": "Klicken Sie hier, um sich anzumelden",
        "free-registration": "Erstellen Sie kostenlos ein Konto, damit Sie die Bilder hinzufügen und Ihre Anzeige veröffentlichen können."
      },
      "statistics": {
        "page-title": "Statistiken der Anzeige"
      }
    },
    "seo": {
      "page-title": "Seitentitel",
      "page-description": "Seitenbeschreibung",
      "page-h1": "Beacon h1 der Seite"
    },
    "statistics": {
      "view-count": "View",
      "view-count_plural": "Views"
    }
  },
  "en": {
    "theme-admin": {
      "toggle-navigation": "Toggle navigation"
    },
    "ui-kit": {
      "under-construction": {
        "work-in-progress": "Work in progress...",
        "feature-in-dev": "This feature is under development. Please come back later."
      },
      "table": {
        "not-specified": "Not specified"
      },
      "select": {
        "select": "Select...",
        "select-or-start-typing": "Select or start typing...",
        "no-results": "No results found",
        "loading": "Loading...",
        "search-prompt": "Start typing to search",
        "screen-reader-status": "{{count}} result available",
        "screen-reader-status_plural": "{{count}} results available"
      },
      "alert": {
        "close": "Close"
      },
      "empty": {
        "text": "Nothing to show yet."
      }
    }
  },
  "fr": {
    "theme-admin": {
      "toggle-navigation": "Afficher / Cacher la navigation"
    },
    "ui-kit": {
      "under-construction": {
        "work-in-progress": "Travaux en cours...",
        "feature-in-dev": "Cette fonctionnalité est encore en développement. Veuillez revenir prochainement."
      },
      "table": {
        "not-specified": "Non spécifié"
      },
      "select": {
        "select": "Veuillez choisir...",
        "select-or-start-typing": "Veuillez choisir ou commencez à taper...",
        "no-results": "Aucun résultat à afficher",
        "loading": "Chargement...",
        "search-prompt": "Commencez à taper pour chercher",
        "screen-reader-status": "{{count}} résultat disponible",
        "screen-reader-status_plural": "{{count}} résultats disponibles"
      },
      "alert": {
        "close": "Fermer"
      },
      "empty": {
        "text": "Il n'y a aucun élément à afficher pour le moment."
      }
    },
    "default": {
      "email": "E-mail",
      "password": "Mot de passe",
      "logging-in": "Connexion en cours",
      "statistics": "Statistiques",
      "ads": "Annonces",
      "bills": "Factures",
      "dashboard": "Tableau de bord",
      "welcome": "Bienvenue",
      "logout": "Déconnexion",
      "login": "Se connecter",
      "back-to-login": "Retour vers la page de connexion",
      "previous": "Précédent",
      "next": "Suivant",
      "yes": "Oui",
      "no": "Non",
      "status": "Statut",
      "deactivated": "Désactivé",
      "activated": "Activé",
      "published": "Publié",
      "expired": "Expirée",
      "not-published": "Non publié",
      "drafted": "Rédigé",
      "disabled": "Désactivé",
      "delete": "Supprimer",
      "manufacturers": "Constructeurs",
      "category": "Catégorie",
      "manufacturer": "Constructeur",
      "entities": "Entités",
      "ad-conditions": "État de l'objet",
      "loading": "Chargement en cours",
      "name": "Nom",
      "ad-condition": "État",
      "price": "Prix",
      "price-tax-excl": "Prix HT",
      "tax-excl": "HT",
      "categories": "Catégories",
      "bookmarks": "Favoris",
      "my-searches": "Mes recherches",
      "pricing": "Tarifs",
      "about": "À propos",
      "contact": "Contact",
      "search": "Recherche",
      "admininitraton": "Administration",
      "sell": "Vendre",
      "my-machine": "Ma machine",
      "public-site": "Site public",
      "seo": "SEO",
      "subscribe": "S'inscrire",
      "account": "Compte",
      "advertiser": "Annonceur",
      "publish": "Publier",
      "extend": "Prolonger",
      "weight": "Poids",
      "tons": "Kg",
      "hours": "heures",
      "icon": "Icône",
      "excavator": "Pelle",
      "bulldozer": "Chargeuse",
      "dump-truck": "Tombereau",
      "compactor": "Compacteur",
      "crane": "Grue",
      "crane-truck": "Camion grue",
      "concasseur": "Concasseur",
      "send": "Envoyer",
      "message": "Contenu du message",
      "locality": "Localité",
      "profile": "Profil",
      "first-name": "Prénom",
      "last-name": "Nom",
      "save": "Enregistrer",
      "company": "Entreprise",
      "phone-number": "Numéro de téléphone",
      "street-address": "Adresse",
      "ad-priority": "Top catégorie",
      "modify": "Modifier",
      "disable": "Désactiver",
      "enable": "Activer",
      "all": "Tout",
      "displayed": "Affiché",
      "avatar": "Avatar",
      "saving": "Sauvegarde en cours",
      "add-file": "Ajouter un fichier",
      "drop-file-here": "Déposez vos fichiers ici",
      "draft": "Rédiger",
      "add-photos": "Ajouter des photos",
      "preview": "Prévisualiser",
      "logo": "Logo",
      "finalize": "Finaliser",
      "publishing": "Publication",
      "extension": "Prolongement",
      "total-due": "Total à payer",
      "total-credits": "Total des crédits",
      "total-to-use": "Total à utiliser",
      "missing-you": "Il vous manque",
      "depict": "Ajouter des photos",
      "checkout": "Payer",
      "see": "Voir",
      "banned": "Bannie",
      "unbanned": "Dé-bannie",
      "ban": "Bannir",
      "unban": "Dé-bannir",
      "previewed": "Pré-visualisé",
      "expire-on": "Expire le",
      "expire-since": "Expirée depuis le",
      "extend-an-ad": "Prolonger une annonce",
      "description": "Description",
      "quantity": "Quantité",
      "total-price": "Prix total",
      "issue-date": "Date d'émission",
      "free": "Offert",
      "vat-rate": "TVA {{rate}}%",
      "final-total": "Total TTC",
      "credits": "Crédits",
      "buy": "Acheter",
      "buy-credits": "Acheter des crédits",
      "payment": "Paiement",
      "credits-bought": "crédits achetés",
      "credits-used": "crédits utilisés",
      "credits-voucher": "crédits offerts",
      "advertisers": "Annonceurs",
      "add-credits-to": "Ajouter des crédits à {{name}}",
      "credits-added": "Crédits ajoutés",
      "pdf-file": "Fichier PDF",
      "approve-publish": "Approuver et publier",
      "payment-pending": "Paiement en attente",
      "order-paid": "Commande payée",
      "order-canceled": "Commande annulée",
      "order-refunded": "Commande remboursée",
      "showcases": "Showcases",
      "showcase": "Showcase",
      "title": "Titre",
      "lead": "Chapô",
      "body": "Corps",
      "medias": "Photos et Video",
      "link": "Lien",
      "featured": "Accueil",
      "close-search": "Fermer la recherche",
      "modify-search": "Modifier la recherche",
      "price-on-demand": "Prix sur demande",
      "download": "Télécharger",
      "empty-list": "Liste vide",
      "all-ads": "Toutes les annonces",
      "banners": "Bannières",
      "banner": "Bannière",
      "start-date": "Date de début",
      "end-date": "Date de fin",
      "format": "Format",
      "desktop": "Desktop",
      "mobile": "Mobile",
      "image": "Image",
      "url": "URL",
      "country": "Pays",
      "currency": "Devise",
      "desktop-and-mobile": "Desktop et Mobile",
      "email-address-link": "Vous avez reçu sur {{email}} un lien qu'il faut cliquer pour confirmer votre adresse e-mail.",
      "email-address-required": "Vous devez confirmer votre adresse e-mail pour publier des annonces.",
      "email-address-not-confirmed": "Votre adresse e-mail n'a pas encore été confirmée.",
      "send-email-confirmation": "Envoyez-moi l'email de confirmation",
      "email-address-confirmation-sent": "L'e-mail de confirmation a été envoyé",
      "at-email": "à {{email}}",
      "ad-bookmark-added": "Annonce ajoutée aux favoris",
      "ad-bookmark-removed": "Annonce retirée des favoris",
      "remove-from-bookmarks": "Retirer des favoris",
      "add-to-bookmarks": "Ajouter aux favoris",
      "ad-bookmark-add-sign-in": "Connectez-vous pour ajouter cette annonce dans vos favoris.",
      "click-here-to-sign-in": "Cliquez-ici pour vous connecter",
      "operation-hours-count": "{{count}} hr",
      "operation-hours-count_plural": "{{count}} hrs",
      "tons-count": "{{count}} Kg",
      "tons-count_plural": "{{count}} Kg",
      "left-count": "{{count}} restant",
      "left-count_plural": "{{count}} restants",
      "credit-count": "{{count}} crédit",
      "credit-count_plural": "{{count}} credits",
      "day": "jour",
      "day_plural": "jours",
      "credit": "crédit",
      "credit_plural": "crédits",
      "credits-available": "crédits disponibles",
      "back-to-ad": "Retour à l'annonce",
      "modify-price": "Modifier le prix",
      "modify-photos": "Modifier les photos",
      "machine-place": "Lieu de la machine",
      "publish-an-ad": "Publier une annonce",
      "execute-search": "Lancer la recherche",
      "back-to-ads": "Retour aux annonces",
      "back-to-profile": "Retour au profil",
      "back-to-account": "Retour à mon compte",
      "back-to-bills": "Retour aux factures",
      "operation-hours": "Heures d'utilisation",
      "checkout-payment": "Passer au paiement",
      "checkout-credits": "Utiliser mes crédits",
      "main-photo-first": "Photo principale en premier",
      "type-card-details": "Saisir vos informations de carte bancaire",
      "number-name-street": "Numéro et nom de voie",
      "available-for-rent": "Disponible à la location",
      "write-a-description": "Écrire une description",
      "postal-code-locality": "Code postal et localité",
      "postal-code-or-locality": "Code postal ou localité",
      "country-locality": "Pays et localité",
      "topbar-first-sentence": "Machines de chantier neuves et d'occasion",
      "drag-drop-files-here-or-click": "Déposez vos fichiers ici ou cliquez sur le bouton",
      "please-select-or-type-category": "Saisir ou sélectionner une catégorie",
      "please-select-or-type-manufacturer": "Saisir ou sélectionner une marque",
      "please-type-at-least-3-characters": "Veuillez saisir au moins 3 caractères...",
      "select-credits-package": "Choisissez le nombre de crédits le plus intéressant pour vous",
      "matches-a-value": "correspond à une valeur",
      "by-credit-unit": "par unité de crédit",
      "account-credited": "Votre compte a reçu les crédits.",
      "confirm-payment": "Valider le paiement",
      "amount-due": "Montant à payer",
      "billing-data": "Informations de facturation",
      "billing-intro-credit": "Pour acheter des crédits, vous devez renseigner les informations concernant votre facturation.",
      "save-buy-credit": "Enregistrer et acheter des crédits",
      "system-confirmation": "Nous sommes en attente d'une confirmation définitive du système de paiement qui va nous confirmer si tout est en ordre.",
      "could-take-seconds": "Cela prendra quelques secondes",
      "checkout-choose-options": "Choix des options de l'annonce",
      "extend-expired-ad": "L'annonce est expirée depuis",
      "extend-published-ad": "L'annonce est publiée et va expirer dans",
      "use-credits-to extend-ad": "Utilisez des crédits pour prolonger la durée de sa publication et de ses options.",
      "ad-has-been-extended": "L'annonce a été prolongée.",
      "sort": "Tri",
      "sort-ascending-expiration-date": "Date d'expiration croissante",
      "sort-descending-expiration-date": "Date d'expiration décroissante",
      "sort-ascending-price": "Prix croissant",
      "sort-descending-price": "Prix décroissant",
      "ad-options": {
        "ad-featured-description": "Votre annonce est listée sur la page d'accueil en tant que 'Machine à la une' pour une durée de {{duration}} jours.",
        "ad-priority-description": "Votre annonce est listée en priorité dans les résultats d'une recherche d'annonces pour une durée de {{duration}} jours, un bandeau marqué 'Top-catégorie' est affiché sur le coin droit de votre annonce.",
        "ad-publishing-description": "Votre annonce est listée dans les recherches dans l'espace publique du site. Le formulaire de contact permet d'envoyer un message au sujet de l'annonce.",
        "ad-extension-description": "Prolongement de la durée de publication de l'annonce."
      },
      "call-advertiser": "Appeler le vendeur",
      "find-the-right-machine": {
        "part1": "Trouvez la",
        "part2": "machine",
        "part3": "de chantiers qu'il vous faut en quelques clics!"
      },
      "read-more": "Lire la suite sur chantiersmagazine.ch",
      "footer": {
        "ad": "Publicité",
        "legal-information": "Informations légales",
        "for-professionnals": "Pour les professionnels",
        "chantiers-machine": "Machines de Chantiers",
        "use-and-sale-conditions": "Conditions générales d'utilisation et de vente",
        "privacy-policy": "Politique de confidentialité",
        "machine-sales-professionnals": "Professionnels de la vente de machine",
        "contact-us": "Contact",
        "prices": "Tarifs",
        "copyrights": {
          "trademark": "2021 Cemento Éditions. Tous droits réservés.",
          "developer": "Développement Web",
          "designer": "Webdesign"
        }
      }
    },
    "error": {
      "common": "Une erreur est survenue. Veuillez recharger la page et recommencer.",
      "mandatory-fields": "Veuillez compléter les champs obligatoires.",
      "disconnected-network": "Une erreur réseau est survenue. Veuillez vérifier votre connexion internet et re-essayer.",
      "not-found": "L'élement n'a pas été trouvé. Veuillez recharger la page et recommencer.",
      "email-confirmation-pending": "Votre compte est en attente de confirmation. Veuillez consulter votre boîte de réception e-mail.",
      "user-already-exists": "Un compte est déjà lié à cette adresse e-mail. Veuillez vous rendre dans la page de connexion pour vous connecter.",
      "email-send-error": "Une erreur est survenue lors de l'envoi de l'e-mail. Veuillez réessayer plus tard.",
      "user-activation": "Une erreur est survenue lors de l'activation du compte utilisateur. Veuillez réessayer plus tard.",
      "user-deactivated": "Le compte a été désactivé.",
      "password-reset": "Une erreur est survenue lors de la réinitialisation du mot de passe. Veuillez réessayer plus tard.",
      "ad-not-found": "Aucune annonce n'a été trouvée avec cet identifiant",
      "manufacturer-not-found": "Aucun constructeur n'a été trouvé avec cet identifiant",
      "manufacturer-linked": "Ce constructeur est utilisé dans {{count}} annonce. Assurez-vous d'avoir supprimé la dite annonce avant d'effectuer cette action.",
      "manufacturer-linked_plural": "Ce constructeur est utilisé dans {{count}} annonces. Assurez-vous d'avoir supprimé les dites annonces avant d'effectuer cette action.",
      "ad-condition-not-found": "Aucun état d'objet n'a été trouvé avec cet identifiant",
      "ad-condition-linked": "Cet état d'objet est utilisé dans {{count}} annonce. Assurez-vous d'avoir supprimé la dite annonce avant d'effectuer cette action.",
      "ad-condition-linked_plural": "Cet état d'objet est utilisé dans {{count}} annonces. Assurez-vous d'avoir supprimé les dites annonces avant d'effectuer cette action.",
      "category-not-found": "Aucune catégorie n'a été trouvée avec cet identifiant",
      "delayed-email-send-failed": "Une erreur est survenue lors de l'envoi de l'e-mail. Une nouvelle tentative d'envoi sera effectuée plus tard. Vous pouvez quitter cette page.",
      "ad-approve-error": "L'annonce ne peut pas être approuvée et publiée. Soit son état actuel ne le permet, soit vous n'avez pas les permissions nécessaires.",
      "ad-disable-error": "L'annonce ne peut pas être désactivée. Soit son état actuel ne le permet, soit vous n'avez pas les permissions nécessaires.",
      "ad-enable-error": "L'annonce ne peut pas être activée. Soit son état actuel ne le permet, soit vous n'avez pas les permissions nécessaires.",
      "ad-ban-error": "L'annonce ne peut pas être bannie. Soit son état actuel ne le permet, soit vous n'avez pas les permissions nécessaires.",
      "ad-unban-error": "L'annonce ne peut pas être dé-bannie. Soit son état actuel ne le permet, soit vous n'avez pas les permissions nécessaires.",
      "ad-extend-error": "L'annonce ne peut pas être prolongée. Soit son état actuel ne le permet, soit vous n'avez pas les permissions nécessaires.",
      "file-type-not-accepted": "Type de fichier non accepté",
      "only-file-types-allowed": "Seul les types de fichier autorisés",
      "ad-media-max": "Nombre de photos maximum atteint ({{count}}).",
      "ad-media-min": "Veuillez conserver au moins une photo ou ajouter une autre photo puis la supprimer.",
      "following-medias-errors-occured": "Les erreurs de fichier suivantes sont survenues:",
      "ad-depict-failed": "Veuillez ajouter au moins une photo.",
      "order-create-failed": "La création de la commande a échoué. Veuillez vérifier vos informations de facturation et les options de publication.",
      "order-payment-setup-failed": "L'initialisation du paiement a échoué. Veuillez contacter l'administrateur du site.",
      "ad-set-price-error": "Une erreur est survenue lors de la sauvegarde du prix. Veuillez vérifier que le prix soisi soit valide.",
      "static-page-not-found": "Aucune page n'a été trouvée avec cet identifiant",
      "ad-order-delete": "Impossible de supprimer une annonce liée à une facture. Vous pouvez bannir l'annonce pour ne plus l'afficher dans la partie publique.",
      "credit-not-enough": "Crédits insuffisants",
      "credit-use-failed": "Erreur lors de l'utilisation des crédits",
      "advertiser-not-found": "Aucun annonceur n'as été trouvé avec cet identifiant",
      "video": "Le format du lien est non valide.",
      "showcase-media-max": "Nombre de photos maximum atteint ({{count}}).",
      "showcase-media-min": "Veuillez conserver au moins une photo ou ajouter une autre photo puis la supprimer."
    },
    "example": {
      "year": "ex: 2015",
      "phone-number": "ex: +41 22 300 55 88"
    },
    "footer": {
      "ad-part1": "Vous souhaitez mettre en vente",
      "ad-part2": "une machine de chantier ?",
      "ad-button": "Déposez votre annonce"
    },
    "packages": {
      "unit": "Crédit à l'unité",
      "pro100": "Pack Pro 100",
      "pro500": "Pack Pro 500",
      "pro1500": "Pack Pro 1500"
    },
    "pages": {
      "account": {
        "page-title": "Compte",
        "welcome": "Bienvenue"
      },
      "ad-conditions": {
        "page-title": "États de l'objet en vente",
        "add-ad-condition": "Ajouter un état d'objet",
        "ad-condition-added": "L'état d'objet a été correctement ajouté",
        "name": "Nom de l'état",
        "edit-ad-condition": "Modifier un état d'objet",
        "ad-condition-edited": "L'état d'objet a été correctement modifié",
        "searching-ad-condition": "Chargement de l'état d'objet",
        "confirm-ad-condition-delete": "Voulez-vous vraiment supprimer cet état d'objet ?",
        "ad-condition-deleted": "L'état d'objet a été correctement supprimé"
      },
      "ads": {
        "model-name": "Nom du modèle",
        "construction-year": "Année de construction",
        "create-ad": "Ajouter une annonce",
        "enable-ad": "Activer l'annonce",
        "ad-created": "L'annonce a été correctement ajoutée",
        "edit-ad": "Modifier une annonce",
        "ad-edited": "L'annonce a été correctement modifiée",
        "searching-ad": "Chargement de l'annonce",
        "confirm-ad-delete": "Voulez-vous vraiment supprimer cette annonce ?",
        "confirm-ad-approve": "Voulez-vous vraiment approuver et publier cette annonce ?",
        "confirm-ad-disable": "Voulez-vous vraiment désactiver cette annonce ?",
        "confirm-ad-enable": "Voulez-vous vraiment activer cette annonce ?",
        "confirm-ad-ban": "Voulez-vous vraiment bannir cette annonce ?",
        "confirm-ad-unban": "Voulez-vous vraiment dé-bannir cette annonce ?",
        "confirm-ad-extend": "Voulez-vous vraiment prolonger la publication de cette annonce ?",
        "ad-deleted": "L'annonce a été correctement supprimée",
        "ad-approved": "L'annonce a été approuvée",
        "ad-disabled": "L'annonce a été désactivée",
        "ad-enabled": "L'annonce a été activée",
        "ad-banned": "L'annonce a été bannie",
        "ad-unbanned": "L'annonce a été dé-bannie",
        "ad-extended": "La publication de l'annonce a été prolongée",
        "description": "Descriptif",
        "contact": "Envoyer un message",
        "example-name": "Par ex: John Doe",
        "example-email": "Par ex: johndoe@example.com",
        "write-a-message": "Bonjour,\n\nJe suis intéressé par votre annonce, ce bien est-il toujours disponible ?\n\nCordialement,",
        "ad-contacted": "Le message de contact a été envoyé avec succès.",
        "phone-number": "Numéro de téléphone",
        "phone-number-example": "Par ex: +41 22 300 55 88",
        "ad-title": "{{manufacturer}} {{modelName}} de {{year}} à {{locality}} | {{condition}} | {{price}}",
        "is-featured": "À la une",
        "share": {
          "mail-subject": "Cette annonce peut vous intéresser",
          "mail-body": "J'ai vu cette annonce sur {{url}}.\n\nJetez-y un coup d'œil !"
        }
      },
      "advertiser-ads": {
        "page-title": "Mes annonces",
        "display-name": "Nom",
        "state": "État de publication",
        "no-data": "Vous n'avez pas encore publié d'annonces.",
        "start-publishing-ad": "Publier votre première annonce"
      },
      "advertiser-bookmarks": {
        "page-title": "Mes annonces favorites",
        "no-data": "Vous n'avez pas d'annonce en favoris.",
        "confirm-bookmark-remove": "Voulez-vous vraiment supprimer cette annonce de vos favoris ?"
      },
      "advertiser-orders": {
        "no-data": "Vous n'avez pas de facture."
      },
      "avatar": {
        "page-title": "Avatar",
        "upload-your-avatar": "Déposez votre avatar ou bien le logo de votre entreprise.",
        "confirm-delete": "Êtes-vous sûr de vouloir supprimer votre avatar ?"
      },
      "banners": {
        "banners": "Bannières",
        "add-banner": "Ajouter une bannière",
        "banner-added": "La bannière a été correctement ajoutée",
        "edit-banner": "Modifier une bannière",
        "banner-edited": "La bannière a été correctement modifiée",
        "searching-banner": "Chargement de la bannière",
        "confirm-delete": "Voulez-vous vraiment supprimer cette image ?",
        "confirm-banner-delete": "Voulez-vous vraiment supprimer cette bannière ?",
        "banner-deleted": "La bannière a été correctement supprimée",
        "halfpage": "Halfpage",
        "billboard": "Billboard",
        "medium-rectangle": "Medium Rectangle",
        "leaderboard": "Leaderboard",
        "missing-banner": "Version de bannière manquante pour l'affichage publique."
      },
      "bills": {
        "order-items": "Articles de la commande",
        "billed-to": "Facturé à",
        "bill-reference": "Référence de la facture"
      },
      "categories": {
        "sub-category": "{{count}} sous-catégorie",
        "sub-category_plural": "{{count}} sous-catégories",
        "sub-categories": "Sous-catégories",
        "add-sub-category": "Ajouter une sous-catégorie",
        "back-to-category": "Retour à la catégorie précédente",
        "add-category": "Ajouter une catégorie",
        "parent": "Parent de la catégorie",
        "name": "Nom de la catégorie",
        "edit-category": "Modifier une catégorie",
        "category-added": "La catégorie a été correctement ajoutée",
        "category-edited": "La catégorie a été correctement modifiée",
        "searching-category": "Chargement de la catégorie",
        "confirm-category-delete": "Voulez-vous vraiment supprimer cette catégorie ?",
        "category-deleted": "La catégorie a été correctement supprimée"
      },
      "home": {
        "title": "Machines de chantier Neuves et d'Occasions"
      },
      "login": {
        "page-title": "Connexion à votre compte",
        "submit": "Connexion",
        "wrong-login-credentials": "L'adresse e-mail et le mot de passe saisis ne correspondent pas.",
        "inactive-account": "Votre adresse e-mail n'a pas encore été confirmée.",
        "error-login": "L'envoi du formulaire a échoué, veuillez re-essayer.",
        "forgotten-password": "Mot de passe oublié",
        "no-account": "Vous n'avez pas de compte ?",
        "click-here-signin": "Cliquez ici pour vous inscrire gratuitement"
      },
      "manufacturers": {
        "manufacturers": "Constructeurs",
        "name": "Nom du constructeur",
        "logo": "Logo",
        "is-featured": "Mise en avant",
        "add-manufacturer": "Ajouter un constructeur",
        "manufacturer-added": "Le constructeur a été correctement ajouté",
        "edit-manufacturer": "Modifier un constructeur",
        "manufacturer-edited": "Le constructeur a été correctement modifié",
        "searching-manufacturer": "Chargement du constructeur",
        "confirm-manufacturer-delete": "Voulez-vous vraiment supprimer ce constructeur ?",
        "manufacturer-deleted": "Le constructeur a été correctement supprimé"
      },
      "media": {
        "page-title": "Photos de l'annonce",
        "upload-your-photos": "Déposer les photos de l'annonce. 10 photos maximum.",
        "confirm-delete": "Êtes-vous sûr de vouloir supprimer cette photo ?",
        "sort-your-photos": "Réordonner les photos de l'annonce.",
        "youtube-link": "Renseigner le lien YouTube vers votre video. Elle sera affichée après vos photos.",
        "confirm-video-delete": "Êtes-vous sûr de vouloir supprimer cette vidéo ?",
        "video-delete": "Supprimer la vidéo de l'annonce",
        "confirm-file-delete": "Êtes-vous sûr de vouloir supprimer ce fichier ?",
        "upload-one-pdf-document": "Déposer un seul fichier PDF."
      },
      "not-found": {
        "page-title": "Page introuvable",
        "page-not-found": "Page introuvable",
        "page-has-not-been-found": "La page n'a pas été trouvée."
      },
      "orders": {
        "page-title": "Mes factures"
      },
      "pages": {
        "page-title": "Pages",
        "edit-page": "Modifier la page",
        "page-edited": "La page a été correctement modifiée",
        "searching-page": "Chargement de la page",
        "title": "Titre",
        "slug": "Slug",
        "content": "Contenu"
      },
      "password-recovery": {
        "page-title": "Mot de passe oublié ?",
        "submit": "Envoyer les instructions de réinitialisation",
        "email-account": "Veuillez saisir l'adresse email utilisée avec votre compte.",
        "reset-instructions": "Les instructions de réinitialisation de votre mot de passe vous seront envoyées à cette adresse.",
        "instructions-sent": "Un lien vous permettant de réinitialiser votre mot de passe a été envoyé à votre adresse email :"
      },
      "password-reset": {
        "page-title": "Changer votre mot de passe",
        "help": "Vous pouvez maintenant réinitialiser (changer) votre mot de passe.",
        "choose-new": "Entrez un nouveau mot de passe",
        "repeat-password": "Répétez le nouveau mot de passe",
        "submit": "Changer le mot de passe",
        "success": "Le mot de passe a été modifié avec succès.",
        "login-redirect": "Vous allez être connecté(e) automatiquement et redirigé(e) vers l'accueil."
      },
      "price": {
        "page-title": "Prix de l'annonce",
        "edit-saved": "Prix enregistré"
      },
      "profile": {
        "page-title": "Profil",
        "saved": "Profil enregistré"
      },
      "publish": {
        "page-title": "Publier une annonce",
        "click-to-see": "Cliquez ici pour voir votre annonce",
        "billing-intro": "Pour publier une annonce, vous devez renseigner les informations concernant votre facturation.",
        "save-next": "Enregistrer et passer à l'étape suivante",
        "not-yet-publish": "Votre annonce n'est pas encore publiée.",
        "publish-continue": "Choisissez vos options et utiliser vos crédits pour finaliser la publication.",
        "payment-finalize": "Procéder au paiement pour finaliser la publication.",
        "billing-data": "Informations de facturation",
        "save-and-depict": "Enregistrer puis ajouter des photos",
        "save-and-checkout": "Enregistrer puis publier l'annonce",
        "save-and-preview": "Enregistrer puis prévisualiser",
        "confirm-payment": "Valider le paiement",
        "amount-due": "Montant à payer",
        "email-confirmation": "Dès la publication de votre annonce, vous recevrez une confirmation par e-mail.",
        "add-video": "Ajouter la vidéo YouTube"
      },
      "showcases": {
        "showcases": "Showcases",
        "add-showcase": "Ajouter un showcase",
        "showcase-added": "Le showcase a été correctement ajouté",
        "edit-showcase": "Modifier un showcase",
        "showcase-edited": "Le showcase a été correctement modifié",
        "searching-showcase": "Chargement du showcase",
        "confirm-showcase-delete": "Voulez-vous vraiment supprimer ce showcase ?",
        "showcase-deleted": "Le showcase a été correctement supprimé",
        "showcase-activated": "Le showcase a été correctement activé",
        "showcase-deactivated": "Le showcase a été correctement désactivé",
        "showcase-featured": "Le showcase a été ajouté à la page d'accueil",
        "showcase-remove-featured": "Le showcase a été retiré de la page d'accueil"
      },
      "sign-up": {
        "page-title": "Inscription gratuite",
        "already-have-an-account": "Vous avez déjà un compte ?",
        "click-here-login": "Cliquez ici pour vous connecter",
        "free-registration": "Créez gratuitement votre compte pour pouvoir ajouter les images et publier votre annonce."
      },
      "statistics": {
        "page-title": "Statistiques de l'annonce"
      }
    },
    "seo": {
      "page-title": "Titre de la page",
      "page-description": "Description de la page",
      "page-h1": "Balise h1 de la page"
    },
    "statistics": {
      "view-count": "vue",
      "view-count_plural": "vues"
    }
  },
  "it": {
    "theme-admin": {
      "toggle-navigation": "Mostra / Nascondi navigazione"
    },
    "ui-kit": {
      "under-construction": {
        "work-in-progress": "Lavori in corso...",
        "feature-in-dev": "Questa funzionalità è ancora in fase di sviluppo. Torna più tardi."
      },
      "table": {
        "not-specified": "Non specificato"
      },
      "select": {
        "select": "Seleziona...",
        "select-or-start-typing": "Seleziona o inizia a digitare...",
        "no-results": "Nessun risultato da visualizzare",
        "loading": "Caricamento...",
        "search-prompt": "Inizia a digitare per la ricerca",
        "screen-reader-status": "{{count}} result available",
        "screen-reader-status_plural": "{{count}} results available"
      },
      "alert": {
        "close": "Chiudi"
      },
      "empty": {
        "text": "Non ci sono elementi da visualizzare al momento."
      }
    },
    "default": {
      "email": "E-mail",
      "password": "Password",
      "logging-in": "Connessione in corso",
      "statistics": "Statistiche",
      "ads": "Annunci",
      "bills": "Fattura",
      "dashboard": "Dashboard",
      "welcome": "Benvenuto",
      "logout": "Logout",
      "login": "Login",
      "back-to-login": "Torna alla pagina di connessione",
      "previous": "Pecedente",
      "next": "Prossimo",
      "yes": "Sì",
      "no": "No",
      "status": "Stato",
      "deactivated": "Disattivato",
      "activated": "Attivato",
      "published": "Pubblicato",
      "expired": "Expirée",
      "not-published": "Non pubblicato",
      "drafted": "Redatto",
      "disabled": "Disattivato",
      "delete": "Cancella",
      "manufacturers": "Marca (produttore)",
      "category": "Categoria",
      "manufacturer": "Marca (produttore)",
      "entities": "Entità",
      "ad-conditions": "Condizioni",
      "loading": "Caricamento in corso",
      "name": "Nome",
      "ad-condition": "Condizioni",
      "price": "Prezzo",
      "price-tax-excl": "Prezzo escluso.",
      "tax-excl": "escluso.",
      "categories": "Categoria",
      "bookmarks": "Favoriti",
      "my-searches": "Le mie ricerche",
      "pricing": "Tariffe",
      "about": "Chi siamo",
      "contact": "Contatti",
      "search": "Cerca",
      "admininitraton": "Amministrazione",
      "sell": "Vendere",
      "my-machine": "la mia macchina",
      "public-site": "Site pubblico",
      "seo": "SEO",
      "subscribe": "Iscriviti",
      "account": "Account",
      "advertiser": "Inserzionista",
      "publish": "Pubblica",
      "extend": "Prolonger",
      "weight": "Peso",
      "tons": "Kg",
      "hours": "ore",
      "icon": "Icona",
      "excavator": "Escavatore",
      "bulldozer": "Pala",
      "dump-truck": "Dumper",
      "compactor": "Rulli compattori",
      "crane": "Gru",
      "crane-truck": "Autogru",
      "concasseur": "Concasseur",
      "send": "Invia",
      "message": "Messaggio",
      "locality": "Località",
      "profile": "Profilo",
      "first-name": "Nome",
      "last-name": "Cognome",
      "save": "Salva",
      "company": "Azienda",
      "phone-number": "Numero di telefono",
      "street-address": "Indirizzo",
      "ad-priority": "Top categoria",
      "modify": "Modifica",
      "disable": "Disattiva",
      "enable": "Attiva",
      "all": "Tutti",
      "displayed": "Mostra",
      "avatar": "Avatar",
      "saving": "Registrazione in corso",
      "add-file": "Aggiungi un file",
      "drop-file-here": "Scarica quì il file",
      "draft": "Scrivi",
      "add-photos": "Aggiungi foto",
      "preview": "Anteprima",
      "logo": "Logo",
      "finalize": "Finalizza",
      "publishing": "Pubblicazione",
      "extension": "Prolongement",
      "total-due": "Importo totale",
      "total-credits": "Total des crédits",
      "total-to-use": "Total à utiliser",
      "missing-you": "Il vous manque",
      "depict": "Ajouter des photos",
      "checkout": "Payer",
      "see": "Voir",
      "banned": "Bannie",
      "unbanned": "Débannie",
      "ban": "Bannir",
      "unban": "Débannir",
      "previewed": "Pré-visualisé",
      "expire-on": "Expire le",
      "expire-since": "Expirée depuis le",
      "extend-an-ad": "Prolonger une annonce",
      "description": "Description",
      "quantity": "Quantité",
      "total-price": "Importo totale",
      "issue-date": "Data di emissione",
      "free": "Offerto",
      "vat-rate": "IVA {{rate}}%",
      "final-total": "Totale IVA inclusa.",
      "credits": "Crediti",
      "buy": "Acquistare",
      "buy-credits": "Acheter des crédits",
      "payment": "Paiement",
      "credits-bought": "crediti acquistati",
      "credits-used": "crediti spesi",
      "credits-voucher": "crédits offerts",
      "advertisers": "Annonceurs",
      "add-credits-to": "Ajouter des crédits à {{name}}",
      "credits-added": "Crédits ajoutés",
      "pdf-file": "Fichier PDF",
      "approve-publish": "Approva e pubblica",
      "payment-pending": "Pagamento in attesa",
      "order-paid": "Ordine pagato",
      "order-canceled": "Ordine annullato",
      "order-refunded": "Ordine rimborsato",
      "showcases": "Showcases",
      "showcase": "Showcase",
      "title": "Titre",
      "lead": "Chapô",
      "body": "Corps",
      "medias": "Photos et Video",
      "link": "Lien",
      "featured": "Accueil",
      "close-search": "Fermer la recherche",
      "modify-search": "Modifier la recherche",
      "price-on-demand": "Prezzo su richiesta",
      "download": "Scarica",
      "empty-list": "Lista vuota",
      "all-ads": "Tutti gli annunci",
      "banners": "Bannières",
      "banner": "Bannière",
      "start-date": "Date de début",
      "end-date": "Date de fin",
      "format": "Format",
      "desktop": "Desktop",
      "mobile": "Mobile",
      "image": "Image",
      "url": "URL",
      "country": "Pays",
      "currency": "Valuta",
      "desktop-and-mobile": "Desktop et Mobile",
      "email-address-link": "Clicca sul link mandato a {{email}} per confermare il tuo indirizzo e-mail.",
      "email-address-required": "Devi confermare il tuo indirizzo e-mail per pubblicare un annuncio.",
      "email-address-not-confirmed": "Il tuo indirizzo e-mail non è stato ancora confermato.",
      "send-email-confirmation": "Mandatemi l'e-mail di conferma",
      "email-address-confirmation-sent": "L'e-mail di conferma è stata mandata",
      "at-email": "a {{email}}",
      "ad-bookmark-added": "Aggiungi annuncio ai tuoi favoriti",
      "ad-bookmark-removed": "Annuncio ritirato dai favoriti",
      "remove-from-bookmarks": "Ritira dai favoriti",
      "add-to-bookmarks": "Aggiungi ai favoriti",
      "ad-bookmark-add-sign-in": "Collegati al tuo account per aggiungere questo annuncio ai tuoi favoriti",
      "click-here-to-sign-in": "Clicca quì per iscriverti gratuitamente",
      "operation-hours-count": "{{count}} ora",
      "operation-hours-count_plural": "{{count}} ore",
      "tons-count": "{{count}} Kg",
      "tons-count_plural": "{{count}} Kg",
      "left-count": "{{count}} restant",
      "left-count_plural": "{{count}} restants",
      "credit-count": "{{count}} credito",
      "credit-count_plural": "{{count}} crediti",
      "day": "jour",
      "day_plural": "jours",
      "credit": "credito",
      "credit_plural": "crediti",
      "credits-available": "crediti disponibili",
      "back-to-ad": "Torna all’annuncio",
      "modify-price": "Modifica prezzo",
      "modify-photos": "Modifica foto",
      "machine-place": "La macchina si trova a (località)",
      "publish-an-ad": "Pubblica un annuncio",
      "execute-search": "Cerca",
      "back-to-ads": "Torna agli annunci",
      "back-to-profile": "Torna al profilo",
      "back-to-account": "'Torna al moi account",
      "back-to-bills": "Torna alle fatture",
      "operation-hours": "Ore di lavoro",
      "checkout-payment": "Vas al pagamento",
      "checkout-credits": "Utiliser mes crédits",
      "main-photo-first": "Scegli foto principale (fai scivolare)",
      "type-card-details": "Inserisci dati carta",
      "number-name-street": "Via e numero",
      "available-for-rent": "Disponible al noleggio",
      "write-a-description": "Scrivi descrizione",
      "postal-code-locality": "CAP e località",
      "postal-code-or-locality": "CAP o località",
      "country-locality": "Pays e località",
      "topbar-first-sentence": "Macchine da cantiere nuove e usate",
      "drag-drop-files-here-or-click": "Scarica quì i file o clicca sur pulsante",
      "please-select-or-type-category": "Digita o seleziona categoria",
      "please-select-or-type-manufacturer": "Digita o seleziona marca",
      "please-type-at-least-3-characters": "Digita almeno 3 caratteri",
      "select-credits-package": "Scegli la quantità di crediti più vantaggiosa per te",
      "matches-a-value": "corrisponde ad un valore",
      "by-credit-unit": "per unità di credito",
      "account-credited": "Votre compte a reçu les crédits.",
      "confirm-payment": "Convalida pagamento",
      "amount-due": "Somma da pagare",
      "billing-data": "Informazione di fatturazione.",
      "billing-intro-credit": "Pour acheter des crédits, vous devez renseigner les informations concernant votre facturation.",
      "save-buy-credit": "Enregistrer et acheter des crédits",
      "system-confirmation": "Siamo in attesa della conferma definitiva del sistema di pagamento.",
      "could-take-seconds": "Il procedimento può durare alcuni secondi.",
      "checkout-choose-options": "Choix des options de l'annonce",
      "extend-expired-ad": "L'annonce est expirée depuis",
      "extend-published-ad": "L'annonce est publiée et va expirer dans",
      "use-credits-to extend-ad": "Utilisez des crédits pour prolonger la durée de sa publication et de ses options.",
      "ad-has-been-extended": "L'annonce a été prolongée.",
      "sort": "Ordina",
      "sort-ascending-expiration-date": "Data (dalla più recente)",
      "sort-descending-expiration-date": "Data (dalla più vecchia)",
      "sort-ascending-price": "Prezzo crescente",
      "sort-descending-price": "Prezzo decrescente",
      "ad-options": {
        "ad-featured-description": "Attiva l’opzione « In prima » perché il tuo annuncio appaia in evidenza sulla home page nel riquadro « Macchine in prima » durante tutto il periodo di inserzione ( {{duration}} giorni).",
        "ad-priority-description": "Attiva l’opzione « Top categoria » perché il tuo annuncio appaia in evidenza sulla pagina corrispondente alla propria categoria (pala, escavatrice, ecc.) nel riquadro « Macchine Top » durante tutta la durata della pubblicazione ( {{duration}} giorni ).",
        "ad-publishing-description": "Il tuo annuncio sarà visibile tra le ricerche generali e nella propria categoria durante un mese (30 giorni). Il formulario di contatto permette alle persone interessate dal tuo annuncio di mettersi direttamente in contatto con te. Alla fine dei 30 giorni ( {{duration}} ), avrai la possibilità, se lo desideri, di prolungare la pubblicazione dell’annuncio.",
        "ad-extension-description": "Prolongement de la durée de publication de l'annonce."
      },
      "call-advertiser": "Chiama il venditore",
      "find-the-right-machine": {
        "part1": "Trova la",
        "part2": "macchina",
        "part3": "da cantiere che ti serve in qualche clic!"
      },
      "read-more": "Leggi l’articolo completo su chantiersmagazine.ch",
      "footer": {
        "ad": "Pubblicità",
        "legal-information": "Informazioni legali",
        "for-professionnals": "Per i professionisti",
        "chantiers-machine": "Machines de Chantiers",
        "use-and-sale-conditions": "Conditions générales d'utilisation et de vente",
        "privacy-policy": "Protezione dati",
        "machine-sales-professionnals": "Professionisti della vendita di macchine da cantiere",
        "contact-us": "Contatti",
        "prices": "Tariffe",
        "copyrights": {
          "trademark": "2021 Cemento Éditions. Tous droits réservés.",
          "developer": "Développement Web",
          "designer": "Webdesign"
        }
      }
    },
    "error": {
      "common": "Si è verificato un errore. Ricarica la pagina e ricomincia.",
      "mandatory-fields": "Completa i campi obligatori.",
      "disconnected-network": "Si è verificato un errore di rete. Verifica la tua connessione e riprova.",
      "not-found": "Not found. Ricarica la pagina e riprova.",
      "email-confirmation-pending": "Il tuo account è in attesa di essere confermato. Verifica la tua casella email.",
      "user-already-exists": "Un account è già collegato a questo indirizzo email. Torna alla pagina di connessione.",
      "email-send-error": "Si è verificato un errore durante l’invio dell’email. Prova più tardi.",
      "user-activation": "Si è verificato un errore al momento dell’attivazione dell’account. Prova più tardi.",
      "user-deactivated": "L’account è stato disattivato.",
      "password-reset": "Si è verificato un errore al momento della reimpostazione dell’email. Prova più tardi.",
      "ad-not-found": "Nessun annuncio è stato trovato con questo ID.",
      "manufacturer-not-found": "Nessun costruttore trovato con questo ID.",
      "manufacturer-linked": "Questa marca è presente in {{count}} annuncio. Assicurati di aver eliminato l’annuncio corrispondente prima di effetuare questa azione.",
      "manufacturer-linked_plural": "Questa marca è presente in {{count}} annunci. Assicurati di aver eliminato l’annuncio corrispondente prima di effetuare questa azione.",
      "ad-condition-not-found": "Nessuna condizione trovata con question ID.",
      "ad-condition-linked": "Questa condizione è presente in {{count}} annuncio. Assicurati di aver eliminato l’annuncio corrispondente prima di effetuare questa azione.",
      "ad-condition-linked_plural": "Questa condizione è presente in {{count}} annunci. Assicurati di aver eliminato l’annuncio corrispondente prima di effetuare questa azione.",
      "category-not-found": "Nessuna categoria è stata trovata con questo ID.",
      "delayed-email-send-failed": "Si è verificato un errore al momento dell’invio dell’email. Un nuovo tentativo sarà fatto automaticamente tra un po’. Puoi uscire da questa pagina.",
      "ad-approve-error": "L’annuncio non può essere approvato e pubblicato. Forse il suo stato attuale non lo permette o forse non hai gli accessi necessari.",
      "ad-disable-error": "L’annuncio non può essere disattivato. Forse il suo stato attuale non lo permette o forse non hai gli accessi necessari.",
      "ad-enable-error": "L’annuncio non può essere attivato. Forse il suo stato attuale non lo permette o forse non hai gli accessi necessari.",
      "ad-ban-error": "L’annuncio non può essere vietata. Forse il suo stato attuale non lo permette o forse non hai gli accessi necessari.",
      "ad-unban-error": "Il divieto dell’annuncio non disattivato. Forse il suo stato attuale non lo permette o forse non hai gli accessi necessari.",
      "ad-extend-error": "L'annonce ne peut pas être prolongée. Soit son état actuel ne le permet, soit vous n'avez pas les permissions nécessaires.",
      "file-type-not-accepted": "Tipo di file non accettato.",
      "only-file-types-allowed": "'Solo tipi di file amessi '",
      "ad-media-max": "Numero massimo di foto raggiunto ({{count}}).",
      "ad-media-min": "Mantenere almeno una foto. Aggiungi un’altra foto prima di sopprimere questa.",
      "following-medias-errors-occured": "'Si sono verificati i seguenti errori di file:'",
      "ad-depict-failed": "Aggiungi lamento une foto.",
      "order-create-failed": "La creazione dell’ordine non è riuscito. Verifica le tue informazioni di fatturazione e le opzioni di pubblicazione.",
      "order-payment-setup-failed": "Impostazione del pagamento del ordine non riuscito. Contatta l’amministratore del sito.",
      "ad-set-price-error": "Errore di prezzo dell’annuncio. Verifica l’esatezza del prezzo.",
      "static-page-not-found": "Nessuna pagina corrisponde a question ID.",
      "credit-not-enough": "Crédits insuffisants",
      "credit-use-failed": "Erreur lors de l'utilisation des crédits",
      "advertiser-not-found": "Aucun annonceur n'as été trouvé avec cet identifiant",
      "video": "Le format du lien est non valide.",
      "showcase-media-max": "Numero massimo di foto raggiunto ({{count}}).",
      "showcase-media-min": "Mantenere almeno una foto. Aggiungi un’altra foto prima di sopprimere questa."
    },
    "example": {
      "year": "anno (es. 2021)",
      "phone-number": "numero di teleforno (es: 022.326.55.88)"
    },
    "footer": {
      "ad-part1": "Vuoi vendere",
      "ad-part2": "une macchina da cantiere?",
      "ad-button": "Inserisci il tuo annuncio"
    },
    "packages": {
      "unit": "Crediti all'unità",
      "pro100": "Pack Pro 100",
      "pro500": "Pack Pro 500",
      "pro1500": "Pack Pro 1500"
    },
    "pages": {
      "account": {
        "page-title": "Account",
        "welcome": "Benvenuto"
      },
      "ad-conditions": {
        "page-title": "Condizioni della macchina in vendita.",
        "add-ad-condition": "Aggiungi condizione macchina",
        "ad-condition-added": "Condizione macchina aggiunto correttamente.",
        "name": "Nome condizione",
        "edit-ad-condition": "Modifica condizione della macchina",
        "ad-condition-edited": "La condizione della macchina è stata correttamente modificata.",
        "searching-ad-condition": "Cambia condizioni macchina.",
        "confirm-ad-condition-delete": "Sei sicuro di rimuovere le condizioni della macchina ?",
        "ad-condition-deleted": "Le condizioni della macchina sono state correttamente rimosse."
      },
      "ads": {
        "model-name": "Nome del modello",
        "construction-year": "Anno costruzione",
        "create-ad": "Aggiungi annuncio",
        "enable-ad": "Attiva l’annuncio",
        "ad-created": "L’annuncio è stato correttamente inserito",
        "edit-ad": "Modifica un’annuncio",
        "ad-edited": "L’annuncio è stato correttamente modificato.",
        "searching-ad": "Caricamento dell’annuncio.",
        "confirm-ad-delete": "Vuoi veramente rimuovere questo annuncio&nbsp;?",
        "confirm-ad-approve": "Vuoi veramente approvare e pubblicare questo annuncio&nbsp;?",
        "confirm-ad-disable": "Vuoi veramente disattivare questo annuncio&nbsp;?",
        "confirm-ad-enable": "Vuoi veramente attivare questo annuncio&nbsp;?",
        "confirm-ad-ban": "Vuoi veramente vietare questo annuncio&nbsp;?",
        "confirm-ad-unban": "Vuoi veramente autorizzare questo annuncio&nbsp;?",
        "confirm-ad-extend": "Voulez-vous vraiment prolonger la publication de cette annonce ?",
        "ad-deleted": "L’annuncio è stato correttamente soppresso.",
        "ad-approved": "L’annuncio è stato approvato.",
        "ad-disabled": "L’annuncio è stato disattivato.",
        "ad-enabled": "L'annuncio è stato attivato.",
        "ad-banned": "L'annuncio è stato vietato.",
        "ad-unbanned": "L'annuncio è stato autorizzato.",
        "ad-extended": "La publication de l'annonce a été prolongée",
        "description": "Descrizione",
        "contact": "Manda un messaggio",
        "example-name": "Par es : Jean Dubat",
        "example-email": "Par es: jean.dubat@bluewin.ch",
        "write-a-message": "Bungiorno,\n\nSono interessato-a dal suo annuncio, la macchina è ancora disponibile ?\n\nCordialmente,",
        "ad-contacted": "Il messaggio di contatto è stato mandato con successo.",
        "phone-number": "Numero di telefono",
        "phone-number-example": "Per es : +41 22 300 50 70 ou 022.300.50.70",
        "ad-title": "{{manufacturer}} {{modelName}} del {{year}} a {{locality}} | {{condition}} | {{price}}",
        "is-featured": "In prima"
      },
      "advertiser-ads": {
        "page-title": "I miei annunci",
        "display-name": "Nome",
        "state": "Stato della pubblicazione",
        "no-data": "Non hai ancora pubblicato nessun annuncio.",
        "start-publishing-ad": "Pubblica il tuo primo annuncio"
      },
      "advertiser-bookmarks": {
        "page-title": "I miei annunci preferiti",
        "no-data": "Non hai annunci favoriti.",
        "confirm-bookmark-remove": "Vuoi veramente eliminare questo annuncio dai tuoi favoriti ?"
      },
      "advertiser-orders": {
        "no-data": "Non hai fatture."
      },
      "avatar": {
        "page-title": "Avatar",
        "upload-your-avatar": "Inserisci il tuo avatar o il logo della tua azienda.",
        "confirm-delete": "Ses sicuro di voler concellare il tuo avatar ?"
      },
      "banners": {
        "banners": "Bannières",
        "add-banner": "Ajouter une bannière",
        "banner-added": "La bannière a été correctement ajoutée",
        "edit-banner": "Modifier une bannière",
        "banner-edited": "La bannière a été correctement modifiée",
        "searching-banner": "Chargement de la bannière",
        "confirm-delete": "Voulez-vous vraiment supprimer cette image ?",
        "confirm-banner-delete": "Voulez-vous vraiment supprimer cette bannière ?",
        "banner-deleted": "La bannière a été correctement supprimée",
        "halfpage": "Halfpage",
        "billboard": "Billboard",
        "medium-rectangle": "Medium Rectangle",
        "leaderboard": "Leaderboard",
        "missing-banner": "Version de bannière manquante pour l'affichage publique."
      },
      "bills": {
        "order-items": "Articoli dell’ordine",
        "billed-to": "Fatturato a",
        "bill-reference": "Riferimento della fattura"
      },
      "categories": {
        "sub-category": "{{count}} sotto-categoria",
        "sub-category_plural": "{{count}} sotto-categorie",
        "sub-categories": "Sotto-categoria",
        "add-sub-category": "Aggiungi una sotto-categoria",
        "back-to-category": "Torna alla categoria precedente",
        "add-category": "Aggiungi una categoria",
        "parent": "Parent de la catégorie",
        "name": "Nome della categoria",
        "edit-category": "Modifica una categoria",
        "category-added": "La catégorie a été correctement ajoutée",
        "category-edited": "La categoria è stata correttamente modificata",
        "searching-category": "Caricamento della categoria",
        "confirm-category-delete": "Vuoi veramente cancellare questa categoria ?",
        "category-deleted": "La categoria è stata correttamente cancellata"
      },
      "home": {
        "title": "Macchine da cantiere nuove e usate"
      },
      "login": {
        "page-title": "Connessione al tuo account",
        "submit": "Connessione",
        "wrong-login-credentials": "L’indirizzo email e la password inseriti non corrispondono.",
        "inactive-account": "Il tuo indirizzo email non è ancora stato confermato.",
        "error-login": "L’invio del formulario non è riuscito, riprova.",
        "forgotten-password": "Password dimenticata",
        "no-account": "Non hai ancora un account ?",
        "click-here-signin": "Clicca quì per iscriverti gratuitamente"
      },
      "manufacturers": {
        "manufacturers": "Marca",
        "name": "Nome della marca",
        "logo": "Logo",
        "is-featured": "In prima",
        "add-manufacturer": "Aggiungi marca",
        "manufacturer-added": "La marca è stata correttamente aggiunta",
        "edit-manufacturer": "Modifica marca",
        "manufacturer-edited": "La marca è stata correttamente modificata",
        "searching-manufacturer": "Caricamento della marca",
        "confirm-manufacturer-delete": "Vuoi veramente cancellare questa marca ?",
        "manufacturer-deleted": "La marca è stata correttamente cancellata"
      },
      "media": {
        "page-title": "Foto dell’annuncio",
        "upload-your-photos": "Scarica le foto dell’annuncio. 10 foto max.",
        "confirm-delete": "Sei sicuro di voler rimuovere questa foto ?",
        "sort-your-photos": "Cambia l’ordine delle foto dell’annuncio.",
        "youtube-link": "Renseigner le lien YouTube vers votre video. Elle sera affichée après vos photos.",
        "confirm-video-delete": "Êtes-vous sûr de vouloir supprimer cette vidéo ?",
        "video-delete": "Supprimer la vidéo de l'annonce",
        "confirm-file-delete": "Êtes-vous sûr de vouloir supprimer ce fichier ?",
        "upload-one-pdf-document": "Déposer un seul fichier PDF."
      },
      "not-found": {
        "page-title": "Pagina introvabile",
        "page-not-found": "Pagina introvabile",
        "page-has-not-been-found": "La pagina non è stata trovata."
      },
      "orders": {
        "page-title": "Le mie fatture"
      },
      "pages": {
        "page-title": "Pagina",
        "edit-page": "Modifica la pagina",
        "page-edited": "La pagina è stata correttamente modificata",
        "searching-page": "Caricamento della pagina",
        "title": "Titolo",
        "slug": "Slug",
        "content": "Contenuto"
      },
      "password-recovery": {
        "page-title": "Password dimenticata ?",
        "submit": "Mandata istruzioni di reimpostazione",
        "email-account": "Digita l’indirizzo email collegato al tuo account.",
        "reset-instructions": "Le istruzioni di reimpostazione della password saranno spedite a questo indirizzo.",
        "instructions-sent": "Un link che ti permette di reimpostare la password è stato mandato al tue indirizzo email :"
      },
      "password-reset": {
        "page-title": "Cambia password",
        "help": "Puoi adesso reimpostare (cambiare) la password.",
        "choose-new": "Digita nuova password",
        "repeat-password": "Ripeti nuova password",
        "submit": "Cambia password",
        "success": "La password è stata modificata con successo",
        "login-redirect": "Stai per essere diretto automaticamente alla homepage"
      },
      "price": {
        "page-title": "Prezzo dell’annuncio",
        "edit-saved": "Prezzo registrato"
      },
      "profile": {
        "page-title": "Profilo",
        "saved": "Profilo registrato"
      },
      "publish": {
        "page-title": "Pubblica annuncio",
        "click-to-see": "Clicca quì per visualizzare il tuo annuncio",
        "billing-intro": "Per pubblicare un annuncio, devi completare le informazioni riguardo alla fatturazione.",
        "save-next": "Salva e scrivi l'annuncio.",
        "not-yet-publish": "Il tuo annuncio non è ancora pubblicato.",
        "publish-continue": "Scegli le opzioni e passa al pagamento per finalizzare la pubblicazione.",
        "payment-finalize": "Procedi al pagamento per finalizzare la pubblicazione.",
        "billing-data": "Informazione di fatturazione.",
        "save-and-depict": "Registra e aggiungi foto.",
        "save-and-checkout": "Registra e pubblica l'annuncio.",
        "save-and-preview": "Registra per visualizzare.",
        "confirm-payment": "Convalida pagamento",
        "amount-due": "Somma da pagare",
        "email-confirmation": "Riceverai una conferma per email non appena il tuo annuncio sarà pubblicato.",
        "add-video": "Ajouter la vidéo YouTube"
      },
      "showcases": {
        "showcases": "Showcases",
        "add-showcase": "Ajouter un showcase",
        "showcase-added": "Le showcase a été correctement ajouté",
        "edit-showcase": "Modifier un showcase",
        "showcase-edited": "Le showcase a été correctement modifié",
        "searching-showcase": "Chargement du showcase",
        "confirm-showcase-delete": "Voulez-vous vraiment supprimer ce showcase ?",
        "showcase-deleted": "Le showcase a été correctement supprimé",
        "showcase-activated": "Le showcase a été correctement activé",
        "showcase-deactivated": "Le showcase a été correctement désactivé",
        "showcase-featured": "Le showcase a été ajouté à la page d'accueil",
        "showcase-remove-featured": "Le showcase a été retiré de la page d'accueil"
      },
      "sign-up": {
        "page-title": "Inscrizione gratuita",
        "already-have-an-account": "Hai già un’account ?",
        "click-here-login": "Clicca quì per il login",
        "free-registration": "Crea gratuitamente il tuo account per aggiungere le immagini e pubblicare il tuo annuncio."
      },
      "statistics": {
        "page-title": "Statistiche dell’annuncio"
      }
    },
    "seo": {
      "page-title": "Titolo pagina",
      "page-description": "Descrizione della pagina",
      "page-h1": "Tag h1 della pagina"
    },
    "statistics": {
      "view-count": "vista",
      "view-count_plural": "viste"
    }
  }
}